export default function createHelpers({ history }) {
  return {
    history
  };
}



// WEBPACK FOOTER //
// ./src/store/createHelpers.js